import React, { useEffect } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { fetchNewCardinality } from 'store/cardinality/cardinalitySlice'
// Corrected import
import { useAppDispatch } from 'store/store'
import RankingForm from 'ui/components/RankingForm'

const RankingsPage: React.FC = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(fetchNewCardinality())
  }, [dispatch])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Cardinalità</h2>
            <p className='text-muted-foreground'>
              Crea una nuova cardinalità dentro l'anno
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <div className='flex flex-col gap-5'>
            <RankingForm />
          </div>
        </div>
      </Main>
    </>
  )
}

export default RankingsPage
